/**
 * Action type to signal the closing of the custom panel.
 */
export const CUSTOM_PANEL_CLOSE = 'CUSTOM_PANEL_CLOSE';
/**
 * Action type to signal the opening of the custom panel.
 */
export const CUSTOM_PANEL_OPEN = 'CUSTOM_PANEL_OPEN';
/**
 * Action type to enable or disable the custom panel dynamically.
 */
export const SET_CUSTOM_PANEL_ENABLED = 'SET_CUSTOM_PANEL_ENABLED';
